<!-- <app-breadcrumbs title="" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs> -->

<div class="row">
  <div class="col-lg-12">
    <h2 class="mb-4 text-primary">
      <i-feather name="triangle" class="text-primary icon-dual"></i-feather>
      Admin Hierarchy
    </h2>

    <div class="card">
      <div class="card-header custom-tr text-end my-3">
        <button
          type="button"
          class="btn btn-primary waves-effect waves-light px-5"
          data-bs-toggle="modal"
          data-bs-target="#hierarchyContentModal"
          data-bs-whatever="Mary"
          (click)="openHierarchyModal(hierarchyAddModal)"
        >
          <i-feather
            name="plus-circle"
            class="text-white icon-dual"
          ></i-feather>
          Add New Hierarchy
        </button>
      </div>

      <div class="card-body">
        <p-table
          [value]="filteredRequests"
          styleClass="p-datatable"
          [paginator]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [tableStyle]="{ 'min-width': '50rem' }"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[5, 10, 20]"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th class="text-center">Admin Level</th>
              <th>Structure</th>
              <th class="text-end">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-request>
            <tr>
              <td>{{ request.name }}</td>
              <td class="text-center">
                <p-badge
                  class="p_badge_color"
                  [value]="request.administrative_level"
                ></p-badge>
              </td>
              <td>
                <app-hierarchy-breadcrumb
                  [breadcrumbItems]="request.breadcrumb"
                ></app-hierarchy-breadcrumb>
              </td>
              <td class="text-end">
                <button
                  type="button"
                  class="btn btn-warning btn-md bg-gradient waves-effect waves-light mx-2"
                  (click)="
                    openHierarchyUpdateModal(hierarchyUpdateModal, request)
                  "
                >
                  <i
                    class="pi pi-cog text-white"
                    style="font-size: 1rem; stroke-width: 0.5"
                  ></i>
                  Edit
                </button>

                <button
                  type="button"
                  class="btn btn-danger btn-md bg-gradient waves-effect waves-light"
                  (click)="
                    deleteAdminHierarchy($event, request?.id, request.name)
                  "
                >
                  <i
                    class="pi pi-trash text-white"
                    style="font-size: 1rem; stroke-width: 0.8"
                  ></i>
                  Delete
                </button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td class="text-center" colspan="5">
                <img
                  *ngIf="filteredRequests?.length === 0"
                  src="../../../../assets/images/cgl/other/noData.PNG"
                  alt="nodata"
                />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- end card body -->
    </div>
    <!-- end card -->
  </div>
  <!-- end col -->
</div>
<!-- end row -->

<ng-template #hierarchyAddModal role="document" let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="hierarchyContentModal">Add New Hierarchy</h5>
    <button
      type="button"
      class="btn-close"
      aria-hidden="true"
      (click)="modal.dismiss('Cross click'); onCloseModel()"
    ></button>
  </div>
  <form (ngSubmit)="createNew()" [formGroup]="hierarchyAddForm">
    <div class="modal-body">
      <div class="mb-3">
        <label for="choices-single-default" class="form-label"
          >Admin Level <span class="required-star">*</span></label
        >
        <ng-select
          [items]="adminLevels"
          formControlName="adminLevel"
          placeholder="Select Admin Level"
          id="adminLevel"
          (change)="loadHierarchy($event)"
          bindLabel="name"
          [(ngModel)]="adminLevel"
          class="my-dropdown"
        >
          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
        <small
          *ngIf="
            isSubmitted &&
            hierarchyAddForm.get('adminLevel')?.hasError('required')
          "
          class="text-danger m-0"
        >
          Please select an admin level
        </small>
        <span *ngIf="hasErrorFormCheck('administrative_level_id')">
          <app-error
            [errors]="filterErrorsByKey('administrative_level_id')"
          ></app-error>
        </span>
      </div>
      <div class="mb-3" *ngIf="parentVisible">
        <label for="choices-single-default" class="form-label"
          >Parent Name <span class="required-star">*</span></label
        >
        <ng-select
          [items]="filteredHierarchyItems"
          placeholder="Select Parent"
          formControlName="parent"
          id="parent"
          bindLabel="name"
          [ngModel]="parent"
          class="my-dropdown"
        >
          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
        <small
          *ngIf="
            isSubmitted && hierarchyAddForm.get('parent')?.hasError('required')
          "
          class="text-danger m-0"
        >
          Parent is required
        </small>
        <span *ngIf="hasErrorFormCheck('parent_id')">
          <app-error [errors]="filterErrorsByKey('parent_id')"></app-error>
        </span>
      </div>
      <div class="mb-3">
        <label for="name" class="col-form-label name-label"
          >Name <span class="required-star">*</span></label
        >
        <input
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="Name"
          id="name"
          appMaxInputLimit
          [maxLength]="45"
        />
        <small
          class="text-danger m-0"
          *ngIf="
            isSubmitted && hierarchyAddForm.get('name')?.hasError('required')
          "
        >
          Name is required
        </small>
        <span *ngIf="hasErrorFormCheck('name')">
          <app-error [errors]="filterErrorsByKey('name')"></app-error>
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="modal.close('Close click'); onCloseModel()"
      >
        Close
      </button>
      <button
        type="submit"
        [disabled]="submittedData"
        class="btn btn-primary waves-effect waves-light"
      >
        <i *ngIf="submittedData" class="mdi mdi-spin mdi-dots-circle"></i>
        {{ submittedData == true ? "Please wait..." : "Add" }}
      </button>
    </div>
  </form>
</ng-template>

<!-- for Update The Hirachy modal -->

<ng-template #hierarchyUpdateModal role="document" let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="hierarchyContentModal">Update Hierarchy</h5>
    <button
      type="button"
      class="btn-close"
      aria-hidden="true"
      (click)="modal.dismiss('Cross click'); onCloseModel()"
    ></button>
  </div>

  <form
    (ngSubmit)="updateHierarchyOnsubmit()"
    [formGroup]="hierarchyUpdateForm"
  >
    <div class="modal-body">
      <div class="mb-3">
        <label for="choices-single-default" class="form-label"
          >Admin Level <span class="required-star">*</span></label
        >
        <ng-select
          [items]="adminLevels"
          formControlName="adminLevel"
          placeholder="Select Admin Level"
          id="adminLevel"
          (change)="loadHierarchyUpdate($event)"
          bindLabel="name"
          class="my-dropdown"
        >
          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
        <small
          *ngIf="
            isSubmitted &&
            hierarchyUpdateForm.get('adminLevel')?.hasError('required')
          "
          class="text-danger m-0"
        >
          Please select an admin level
        </small>
        <span *ngIf="hasErrorFormCheck('administrative_level_id')">
          <app-error
            [errors]="filterErrorsByKey('administrative_level_id')"
          ></app-error>
        </span>
      </div>
      <div class="mb-3" *ngIf="parentVisible">
        <label for="choices-single-default" class="form-label"
          >Parent Name
          <span
            class="required-star"
            *ngIf="this.hierarchyUpdateForm.get('adminLevel')?.value?.id != 1"
            >*</span
          ></label
        >
        <ng-select
          [items]="filteredHierarchyItems"
          placeholder="Select Parent"
          formControlName="parent"
          id="parent"
          bindLabel="name"
          class="my-dropdown"
        >
          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.name }}
          </ng-template>
        </ng-select>
        <small
          *ngIf="
            isSubmitted &&
            hierarchyUpdateForm.get('parent')?.hasError('required')
          "
          class="text-danger m-0"
        >
          Parent is required
        </small>
        <span *ngIf="hasErrorFormCheck('parent_id')">
          <app-error [errors]="filterErrorsByKey('parent_id')"></app-error>
        </span>
      </div>
      <div class="mb-3">
        <label for="name" class="col-form-label name-label"
          >Name <span class="required-star">*</span></label
        >
        <input
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="Name"
          id="name"
          appMaxInputLimit
          [maxLength]="45"
        />
        <div
          *ngIf="
            isSubmitted && hierarchyUpdateForm.get('name')?.hasError('required')
          "
        >
          <small class="text-danger m-0">Name is required</small>
        </div>
        <span *ngIf="hasErrorFormCheck('name')">
          <app-error [errors]="filterErrorsByKey('name')"></app-error>
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-light"
        (click)="modal.close('Close click'); onCloseModel()"
      >
        Close
      </button>
      <button
        type="submit"
        [disabled]="submittedData"
        class="btn btn-primary waves-effect waves-light"
      >
        <i *ngIf="submittedData" class="mdi mdi-spin mdi-dots-circle"></i>
        {{ submittedData == true ? "Please wait..." : "Edit" }}
      </button>
    </div>
  </form>
</ng-template>

<!-- delete component -->
<div class="card flex justify-content-center">
  <p-confirmDialog #cd>
    <ng-template pTemplate="headless" let-message>
      <div
        style="
          background-color: white;
          border-radius: 10px;
          display: flex;
          padding: 2rem;
        "
        class="flex flex-column align-items-center surface-overlay border-round"
      >
        <div
          style="
            width: 5rem;
            height: 5rem;
            border-radius: 60%;
            display: flex;
            background-color: #ee5253 !important;
          "
          class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem"
        >
          <i
            style="color: white; width: 30px; height: 30px; font-size: xx-large"
            class="pi pi-question"
          ></i>
        </div>
        <span
          style="font-weight: bold; font-weight: bold; font-size: 1.4rem"
          class="text-2xl block mb-2 mt-3"
        >
          {{ message.header }}
        </span>
        <p class="mb-0">
          Delete this
          <span style="color: #0a3d2c; font-weight: 500">{{
            message.message
          }}</span>
        </p>
        <div
          style="display: flex; width: 100%; justify-content: center"
          class="mt-4"
        >
          <button
            style="
              width: 8rem;
              height: 2.3rem;
              border-radius: 7px;
              border: 1px solid red;
              margin: 0 5px 0px 5px;
            "
            (click)="cd.accept()"
            pButton
            label="Delete"
            class="deleteCustomButtonPlantation p-2"
          ></button>
          <button
            style="
              width: 8rem;
              height: 2.3rem;
              border-radius: 7px;
              margin: 0 5px 0px 5px;
            "
            (click)="cd.reject()"
            pButton
            label="Cancel"
            class="p-button-outlined p-2"
          ></button>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>
</div>
